import { isHeadless } from 'utils/headless';
import useUser from './useUser';

const useIsApprovedUser = () => {
  const { isPendingReview, isRegistering } = useUser();

  const isNotApprovedUser = isHeadless() || isPendingReview || isRegistering;
  return !isNotApprovedUser;
};

export default useIsApprovedUser;
